import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

/**
 * It was the component taken from syndication, so the values named syndication actually refer to the Iocavailable values.
 * The `IOCAvailable` function is a React component that renders a dropdown menu for selecting
 * Iocavailable options.
 * @returns a JSX element.
 */
function IOCAvailable({ Iocavailable, SetIocavailable, customPathname, label = "Index of Charges available?", isPopupOpen, setIsPopupOpen }) {
    const { Syndications, refineSearchFilters } = useContext(PeFilterContext);
    
    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.syndication?.map(value => value.value) ?? [];
        SetIocavailable(Syndications?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.value) })));
    }, [Syndications, customPathname, refineSearchFilters, SetIocavailable]);

    const handleIocavailableChange = (e) => {
        const value = e.target.value;
        SetIocavailable(Iocavailable?.map(type => ({ ...type, isChecked: value === "" ? false : type.value === value })));
    };

    const selected = Iocavailable?.filter(option => option.isChecked)?.at(0);

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label}</span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <h3 className="text-sm font-medium mb-3 text-gray-700">{label}</h3>
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto grid grid-cols-3">
                                <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="iocAvailable"
                                        value=""
                                        checked={!selected}
                                        onChange={handleIocavailableChange}
                                        className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                    />
                                    <span className="text-[13px]">All</span>
                                </label>
                                {Iocavailable && Iocavailable?.length > 0 ? (
                                    Iocavailable?.map((ioc, index) => (
                                        <label key={index} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                            <input
                                                type="radio"
                                                name="iocAvailable"
                                                value={ioc.value}
                                                checked={selected?.value === ioc.value}
                                                onChange={handleIocavailableChange}
                                                className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                            />
                                            <span className="text-[13px]">{ioc.name}</span>
                                        </label>
                                    ))
                                ) : (
                                    <div className="text-[13px] text-gray-500">No results found!</div>
                                )}
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default IOCAvailable;
